import { useMutation, useQueryClient } from '@tanstack/react-query';
import { configApi } from '../../configApi';

const deleteDocument = async (itemId: string, docId: string) => {
  const response = await configApi.delete(
    `/api/title-submissions/items/${itemId}/documents/${docId}/`
  );
  return response.data;
};

export const useDeleteTitleDocument = (submissionId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ itemId, docId }: { itemId: string; docId: string }) =>
      deleteDocument(itemId, docId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['title-submission', submissionId] });
      queryClient.invalidateQueries({ queryKey: ['title-submission-score-preview', submissionId] });
    },
  });
};
